var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.1875C15.7812 4.375 16 4.6875 16 5.03125C16 5.5625 15.5625 6 15 6H0.96875C0.40625 6 0 5.5625 0 5.03125C0 4.6875 0.1875 4.375 0.46875 4.1875L7.75 0.09375C7.90625 0 8.0625 0 8.21875 0.09375L15.5 4.1875ZM14.9062 5L8 1.09375L1.0625 5H6.40625C6.28125 4.78125 6.25 4.53125 6.25 4.25C6.25 3.3125 7.03125 2.5 8 2.5C8.9375 2.5 9.75 3.3125 9.75 4.25C9.75 4.53125 9.6875 4.78125 9.5625 5H14.9062ZM8 5C8.40625 5 8.75 4.6875 8.75 4.25C8.75 3.84375 8.40625 3.5 8 3.5C7.5625 3.5 7.25 3.84375 7.25 4.25C7.25 4.6875 7.5625 5 8 5ZM2 7H3V11H5.5V7H6.5V11H9.5V7H10.5V11H13V7H14V11C14.25 11 14.5 11.25 14.5 11.5C14.5 11.7812 14.25 12 14 12H2C1.71875 12 1.5 11.7812 1.5 11.5C1.5 11.25 1.71875 11 2 11V7ZM14.75 13C15 13 15.25 13.25 15.25 13.5C15.25 13.7812 15 14 14.75 14H1.25C0.96875 14 0.75 13.7812 0.75 13.5C0.75 13.25 0.96875 13 1.25 13H14.75ZM15.5 15C15.75 15 16 15.25 16 15.5C16 15.7812 15.75 16 15.5 16H0.5C0.21875 16 0 15.7812 0 15.5C0 15.25 0.21875 15 0.5 15H15.5Z",
    fill: "#58595B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAccount);
export default __webpack_public_path__ + "static/media/bankAccount.65a1ec28e6770489d4d5432c60b56abe.svg";
export { ForwardRef as ReactComponent };